import React from "react";
import { Link } from "react-router-dom";

// Default wording. The admin (Home Sections) can change it; it's saved in siteConfig/homepage.bundleSection
export const DEFAULT_BUNDLES = {
    enabled: true,
    heading: "Our Bundles",
    intro: "Every bundle is built around the books in our sagas. Pick the one that fits how you like to read.",
    cards: [
        {
            title: "Reader's Bundle",
            text: "A physical book plus its digital version. Read on paper, and take the ebook with you.",
        },
        {
            title: "Starter Bundle",
            text: "The first book of each saga, in print.",
        },
        {
            title: "Starter Reader's Bundle",
            text: "The first book of each saga, in print and digital.",
        },
    ],
};

export default function BundlesExplainer({ config }) {
    const c = { ...DEFAULT_BUNDLES, ...(config || {}) };
    if (!c.enabled) return null;
    const cards = c.cards && c.cards.length > 0 ? c.cards : DEFAULT_BUNDLES.cards;

    return (
        <section style={{ padding: "80px 20px", background: "#fff" }}>
            <div style={{ maxWidth: 1100, margin: "0 auto" }}>
                <h2 style={{ fontFamily: "'Playfair Display', serif", textAlign: "center", fontSize: "2.2rem", color: "var(--primary)", margin: "0 0 12px" }}>
                    {c.heading}
                </h2>
                <p style={{ textAlign: "center", color: "#666", maxWidth: 640, margin: "0 auto 48px", lineHeight: 1.6 }}>
                    {c.intro}
                </p>

                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 24 }}>
                    {cards.map((card, i) => (
                        <div key={i} style={{ border: "1.5px solid #eee", borderRadius: 16, padding: 28, background: "#fbfaf7" }}>
                            <span style={{ fontSize: 12, fontWeight: 700, color: "var(--accent)", textTransform: "uppercase", letterSpacing: 1 }}>
                                Bundle
                            </span>
                            <h3 style={{ fontFamily: "'Playfair Display', serif", margin: "8px 0 10px", color: "var(--primary)" }}>
                                {card.title}
                            </h3>
                            <p style={{ color: "#555", lineHeight: 1.6, margin: 0 }}>{card.text}</p>
                        </div>
                    ))}
                </div>

                <div style={{ textAlign: "center", marginTop: 40 }}>
                    <Link
                        to="/shop"
                        style={{ display: "inline-block", background: "var(--accent)", color: "#fff", padding: "14px 32px", borderRadius: 12, textDecoration: "none", fontWeight: 700 }}
                    >
                        Shop bundles
                    </Link>
                </div>
            </div>
        </section>
    );
}
